import { Typography } from 'antd'
import { type TitleProps as AntdTitleProps } from 'antd/lib/typography/Title'
import { useMemo } from 'react'
import styles from './styles.module.scss'
interface TitleProps extends AntdTitleProps {
  weight?: 400 | 500 | 600
  noMargin?: boolean
  textAlign?: React.CSSProperties['textAlign']
}

export function Title({ weight = 600, noMargin, textAlign, className, ...props }: TitleProps) {
  const classNames = useMemo(() => {
    const array = []
    const weightOptions = {
      400: styles.weight400,
      500: styles.weight500,
      600: styles.weight600,
    }

    array.push(className)
    array.push(weightOptions[weight])
    if (noMargin) array.push(styles.noMargin)

    return array.join(' ')
  }, [className, noMargin, weight])

  return <Typography.Title {...props} style={{ textAlign }} className={classNames} />
}
